import React, {useEffect} from "react";
import { Drawer, List } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { IUser } from "../../../Models/Models";
import { UserAvatar } from "../../Common";
import { getAllUsersInitiate } from "../../../View/Products/Actions/UserActions";
import { allUsersSelector, loadingAllUsersSelector } from "../../../Reducers/Selectors/UserSelectors";

interface IActiveUsersProps {
    onClose: () => void;
};

const ActiveUsers = (props: IActiveUsersProps): JSX.Element => {
    /** misc */
    const dispatch = useDispatch();
    /** selectors */
    const allUsers: IUser[] = useSelector(allUsersSelector);
    const loading: boolean = useSelector(loadingAllUsersSelector);
    /** effects */
    useEffect(() => {
        dispatch(getAllUsersInitiate());
    }, []);

    const usersToShow: IUser[] = allUsers?.filter((user: IUser) => {
        return !user.isSetup && user.isActive;
    })
        .sort((a: IUser, b: IUser): number => {
            if (a.loginStatus < b.loginStatus) return -1;
            else if (a.loginStatus > b.loginStatus) return 1;
            return 0;
        });

    return (
        <Drawer
            title="Active Users"
            placement="right"
            width="342"
            closable={true}
            visible={true}
            onClose={props.onClose}
            style={{
                boxShadow: "inset 0 -1px 0 0 rgba(67, 74, 84, 0.05)"
            }}>
            <List
                itemLayout="horizontal"
                dataSource={usersToShow}
                loading={loading}
                locale={{
                    emptyText: (
                        <p>No Users</p>
                    )
                }}
                renderItem={(u: IUser) => (
                    <List.Item
                        style={{
                            height: "55px",
                            /** override AntD */
                            padding: "0 0 0 20px !important"
                        }}>
                        <List.Item.Meta
                            avatar={<UserAvatar user={u} />}
                            title={
                                <div
                                    style={{
                                        maxWidth: "240px",
                                        marginTop: "4px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}>
                                    {u.fullName}
                                </div>
                            }
                        />
                    </List.Item>
                )}
            />
        </Drawer>
    );
};

export default ActiveUsers;
